import "./Question.css";

import SectionHeader from "../../_components/section-header/SectionHeader";

import { COLLAPSE, EXPAND } from "../../_media/assets";

const Question = ({ id, question, answer, isShowing, handleShowing }) => {
  const handleKeyPress = (e) => {
    if (e.code === "Enter" || e.code === "Space") handleShowing();
  };

  const borderBottom = {
    borderBottom: `2px solid ${isShowing ? "#b279f1" : "#cfc8d8"}`,
  };

  return (
    <div
      className="Question"
      id={id}
      onClick={handleShowing}
      style={borderBottom}
    >
      <div className="Question-question-wrapper">
        <SectionHeader small text={question} />
        <img
          role="button"
          onKeyUp={handleKeyPress}
          src={isShowing ? COLLAPSE : EXPAND}
          alt={`Pick to ${
            isShowing ? "collapse" : "expand"
          } question ${question}`}
          tabIndex={0}
        />
      </div>
      <p className={`Question-answer${isShowing ? " showing" : ""}`}>
        {answer}
      </p>
    </div>
  );
};

export default Question;
